import {
  authHeader,
  clearTokenCookie,
  config,
  getTokenCookie,
  options,
  getCookie,
  history,
  getLocale,
  setTokenCookie,
} from "../../components/common/helpers";
import { polyfill } from "es6-promise";
import { fetch } from "whatwg-fetch";
import Cookies from "universal-cookie";

polyfill();

export const userService = {
  login,
  logout,
  registration,
  userData,
  socialLogin,
  loginToAdminPortal,
  logoutFromAdminPortal,
};

function login(username, password) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include", // Required for cookies
    body: JSON.stringify({ email: username, password: password }),
  };
  return fetch(config.apiUrl + "/login", requestOptions)
    .then(handleResponse, handleError)
    .then((user) => {
      // login successful if there's a token in the response
      if (user && user.token) {
        setTokenCookie(user.token);
        const cookies = new Cookies();
        cookies.remove("userTemperaturePrefObj");
        user.user[0].preferences.length > 0
          ? cookies.set(
              "userTemperaturePrefObj",
              JSON.stringify(
                user.user[0].preferences.filter(
                  (preferences) =>
                    preferences.preferenceType === "TEMPERATURE_UNIT",
                ),
              ),
            )
          : cookies.set(
              "userTemperaturePrefObj",
              JSON.stringify({
                preferenceValue: "C7001ABE-BC55-11E2-9678-15B654818C3B",
              }),
            );
      }
      return user;
    });
}

function socialLogin(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "text/html",
    },
    body: JSON.stringify(data),
  };
  return fetch(config.apiUrl + "/login", requestOptions)
    .then(handleResponse, handleError)
    .then((user) => {
      // login successful if there's a token in the response
      if (user && user.token) {
        setTokenCookie(user.token);
      }
      return user;
    })
    .catch((err) => {
      console.log("error in social login", err);
    });
}

const language = getLocale(window.location.pathname, true);

function logout() {
  clearTokenCookie();
  history.push(language + "/stores/home");
}

function logoutFromAdminPortal() {
  clearTokenCookie();
  history.push(language + "/admin/login");
}

function userData() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(config.apiUrl + "/usertoken", requestOptions)
    .then(handleResponse, handleError)
    .then((user) => {
      // login successful if there's a token in the response
      if (user && !user.token) {
        user.token = getTokenCookie();
      } else if (user && user.token) {
        setTokenCookie(user.token);
      }

      return user;
    });
}

function registration(
  firstName,
  lastName,
  emailAddress,
  password,
  roleId,
  userAccountId,
  isEmailOk,
  jobRoleId,
  countryId,
  organizationId,
) {
  const buildVersion = getCookie("buildVersion");
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "XT-UserAgent": "flukeconnect-web/" + buildVersion,
    },
    body: JSON.stringify({
      user: {
        firstName: firstName,
        lastName: lastName,
        emailAddr: emailAddress,
        pword: password,
        roleId: roleId,
        userAccountId: userAccountId,
        emailOk: isEmailOk,
        jobRoleId: jobRoleId,
        countryId: countryId,
        organizationId: organizationId,
      },
      organization: { organizationId: organizationId },
    }),
  };
  return fetch(
    options(config.apiUrl + "/user/individual"),
    requestOptions,
  ).then(handleResponse, handleError);
}

function handleResponse(response) {
  return new Promise((resolve, reject) => {
    if (response.ok) {
      // return json if it was returned in the response
      var contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") > -1) {
        response.json().then((json) => resolve(json));
      } else {
        resolve();
      }
    } else {
      // return error message from response body
      response.text().then((text) => reject(text));
    }
  });
}

function handleError(error) {
  console.log("Received errorr api data : " + error);
  return Promise.reject(error && error.message);
}

function loginToAdminPortal(username, password) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "text/html",
    },
    body: JSON.stringify({ email: username, password: password }),
  };
  return fetch(config.apiUrl + "/admin/login", requestOptions)
    .then(handleResponse, handleError)
    .then((user) => {
      // login successful if there's a token in the response
      if (user && user.token) {
        setTokenCookie(user.token);
      }
      return user;
    });
}
